import React from 'react';
import { Check } from 'lucide-react';

const PricingCard = ({ title, price, credits, perCredit, popular, features = [], onSelect, badgeText }) => {
	return (
		<div className={`relative bg-white rounded-2xl p-8 shadow-lg border ${popular ? 'border-blue-500 ring-2 ring-blue-200 scale-[1.02]' : 'border-gray-200'}`}>
			{(popular || badgeText) && (
				<div className="absolute -top-3 right-4 bg-blue-600 text-white text-xs font-bold px-3 py-1 rounded-full">
					{badgeText || 'Most Popular'}
				</div>
			)}
			<h3 className="text-2xl font-bold text-gray-900">{title}</h3>
			<div className="mt-2">
				<div className="text-4xl font-extrabold text-blue-600">₹{price}</div>
				<div className="text-gray-600">
					<span className="font-semibold">{credits}</span> Credits • <span className="text-gray-500">₹{perCredit} / credit</span>
				</div>
			</div>
			<ul className="mt-6 space-y-2">
				{features.map((feature, idx) => (
					<li key={idx} className="flex items-start">
						<Check className="w-5 h-5 text-green-500 mt-0.5 mr-2" />
						<span className="text-gray-700">{feature}</span>
					</li>
				))}
			</ul>
			<button
				onClick={onSelect}
				className={`mt-8 w-full py-3 rounded-lg font-semibold transition-colors ${popular ? 'bg-blue-600 text-white hover:bg-blue-700' : 'bg-gray-900 text-white hover:bg-gray-800'}`}
			>
				Get Started
			</button>
		</div>
	);
};

export default PricingCard;


